import { render, staticRenderFns } from "./noble.vue?vue&type=template&id=84ba3d78&scoped=true&"
import script from "./noble.vue?vue&type=script&lang=js&"
export * from "./noble.vue?vue&type=script&lang=js&"
import style0 from "./noble.vue?vue&type=style&index=0&id=84ba3d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba3d78",
  null
  
)

export default component.exports